import React from 'react'
import { Link } from 'react-router-dom'
import { Jumbotron, Button, Container } from 'react-bootstrap'

import teamMember_about from '../../images/teammember-about.png'
// import teamMember_about from '../../images/data-center-service.jpg'
import team from './team.png'

import './jumbo.css'

const Jumbo = () => {
  const mystyle = {}

  return (
    <>
      <Container
        className='contact-content my-4 debug-border'
        style={{ display: 'flex' }}
      >
        <Jumbotron className='text-center'>
          <div className='jumboContent-wrapper'>
            <h1>WE ARE CLOUDSICHER</h1>
            <img
              src={teamMember_about}
              class='img-fluid'
              alt='Responsive image'
            ></img>
            <p>
              Here in cloudsicher we have expert coming from different IT
              professional background and from different industries. We have
              been working in German Tech industries for last 15 years and we
              want to bring our expertise and knowledge to help our clients.
            </p>
            {/* <p>
            <Button variant='primary'>Learn more</Button>
          </p> */}
          </div>
        </Jumbotron>
      </Container>
      <div>
        <img></img>
      </div>
    </>
  )
}

export default Jumbo
